/* beautiful-react-hooks version: 0.30.1 */
var geoStandardOptions = Object.create(null);
geoStandardOptions.enableHighAccuracy = false;
geoStandardOptions.timeout = 0xFFFFFFFF;
geoStandardOptions.maximumAge = 0;
var geolocationStandardOptions = Object.freeze(geoStandardOptions);

export default geolocationStandardOptions;
